import getFileById from '@picsart/cloud-storage/api/getFileById';

import { ErrorMessages } from '@/consts/errors';
import { getCloudStorageHeaders, withCloudStorageErrorHandling } from './utils';

type Params = {
  uid: string;
};

const getFile = async ({ uid }: Params) => {
  return withCloudStorageErrorHandling(async () => {
    const { response } = await getFileById({
      headers: getCloudStorageHeaders(),
      fileId: uid,
    });
    return response;
  }, ErrorMessages.driveFile);
};

export { getFile };
